<template>
  <div>
    <div class="background"></div>
    <div class="dialog">
      <div class="text-area">
        <p class="text" :class="{ visible: animationNum === 3 }">
          正解ポイントをゲットしました！<br />
          引き続きスイスイ旅をお楽しみください
        </p>
      </div>
      <div class="main-area">
        <div class="img-wrapper">
          <img
            class="answer-img"
            :class="{ visible: animationNum === 1 }"
            @click="onClick"
            src="@/assets/mission/1.png"
          />
          <img
            class="answer-img"
            :class="{ visible: animationNum === 2 }"
            @click="onClick"
            src="@/assets/mission/2.png"
          />
          <img
            class="answer-img"
            :class="{ visible: animationNum === 3 }"
            @click="onClick"
            src="@/assets/mission/3.png"
          />
        </div>
        <div class="point-counter">
          <div class="point-wrapper">
            <p
              class="point"
              :class="{ visible: animationNum === 1 || animationNum === 2 }"
            >
              {{ beforePoint }}
            </p>
            <p class="point" :class="{ visible: animationNum === 3 }">
              {{ afterPoint }}
            </p>
          </div>
          <p class="point-text">ポイント</p>
        </div>
      </div>
      <div class="button-area">
        <ButtonTextLink
          class="button"
          :class="{ visible: animationNum === 3 }"
          text="閉じる"
          @click-text="onClickClose"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TitleArea from "@/components/Atoms/TitleArea";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";

export default {
  name: "show-mission-area",
  components: {
    TitleArea,
    ButtonTextLink,
  },
  props: {
    getPoint: { type: Number, require: true },
  },
  computed: {
    ...mapState(["registrationData"]),
    beforePoint() {
      return this.registrationData.Point - this.getPoint;
    },
    afterPoint() {
      return this.registrationData.Point;
    },
  },
  data() {
    return {
      animationNum: 1,
    };
  },
  methods: {
    onClick() {
      this.animationNum = this.animationNum + 1;
      if (this.animationNum === 4) {
        this.animationNum = 1;
      }
    },
    onClickClose() {
      this.$emit("click-close");
    },
  },
  mounted() {
    setTimeout(() => {
      this.animationNum = 2;
    }, 1000);
    setTimeout(() => {
      this.animationNum = 3;
    }, 2000);
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -2rem;
}
.dialog {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-55%);
  background-color: white;
  z-index: 1001;
  width: 80vw;
  padding: 1rem;
  border-radius: 12px;
}

.text-area {
  height: 5rem;
  text-align: center;
  .text {
    transition: all 300ms ease-in-out;
    opacity: 0;
    &.visible {
      opacity: 1;
    }
  }
}

.main-area {
  display: flex;
  height: 15vh;
  width: 80%;
}

.img-wrapper {
  position: relative;
  aspect-ratio: 69/113;
  height: 100%;

  .answer-img {
    position: absolute;
    height: 100%;
    object-fit: contain;
    transition: all 300ms ease-in-out;
    opacity: 0;
    top: 25px;
    &.visible {
      opacity: 1;
      top: 0px;
    }
  }
}

.point-counter {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  .point-wrapper {
    position: relative;
    height: 2rem;
    width: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .point {
      position: absolute;
      transition: all 500ms ease-in-out;
      opacity: 0;
      top: 25px;
      text-align: center;
      font-size: 1.8rem;
      margin: 0;
      &.visible {
        opacity: 1;
        top: 0px;
      }
    }
  }
  .point-text {
    color: #7c7c7c;
    font-size: 0.8rem;
    margin: 0.5rem 0 0;
  }
}

.button-area {
  width: 100%;
  font-weight: 700;
  .button {
    transition: all 500ms ease-in-out;
    opacity: 0;
    visibility: hidden;
    &.visible {
      opacity: 1;
      visibility: visible;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuizMission/GetPointDailog.vue